import { Formik } from "formik";
import Loader from "../../loader";
import StepsDots from "../../form/StepsDots";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import PdfOrImageUploader from "../../pdfImage uploader";
import { profileStep3Schema } from "../../../utils/schema";
import { setRegisterStep } from "../../../redux/features/find-a-job/reducers/authReducer";
import { profileStep3Submit } from "../../../redux/features/find-a-job/actions/authAction";
import {
  getFreelancerFormData,
  updateFreelancerFormData,
} from "../../../utils/pip";

const ProfileSetupStep3 = () => {
  const dispatch = useDispatch();
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const savedData = getFreelancerFormData()?.profileStep3 || {};

  const handleStep3 = (values) => {
    const callback = (res) => {
      if (res?.success) {
        updateFreelancerFormData("profileStep3", values);
        dispatch(setRegisterStep("profileStep4"));
      }
    };

    const formData = new FormData();
    formData.append("website_or_portfolio", values?.website_or_portfolio);
    (values.projects || []).forEach((file) => {
      formData.append("projects", file);
    });
    (values.cv || []).forEach((file) => {
      formData.append("cv", file);
    });

    dispatch(profileStep3Submit({ payload: formData, callback }));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/setp_4_freelance_img_left.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                {/* <div
                  className="ct_back_top_btn"
                  onClick={() => {
                    dispatch(setRegisterStep("profileStep2"));
                  }}
                >
                  <i class="fa-solid fa-arrow-left"></i>
                </div> */}
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                    Your Experience & Projects
                  </h2>
                  <p className="mb-0 ct_fs_16 mt-2 ct_darkblue_text mx-auto">
                    Share your past roles and proudest work to give us a full
                    picture of your journey.
                  </p>
                </div>
                <Formik
                  initialValues={savedData}
                  validationSchema={profileStep3Schema}
                  onSubmit={(values, actions) => {
                    handleStep3(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setTouched,
                  }) => (
                    <form onSubmit={handleSubmit} class="ct_mt_40">
                      <div className="row">
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_darkblue_text ct_fs_14">
                              {" "}
                              Resume{" "}
                            </label>
                            <PdfOrImageUploader
                              maxFiles={20}
                              multiple={true}
                              acceptType="application/pdf,image/*"
                              placeholder="Upload CV (PDF or Image)"
                              existingFiles={
                                values?.cv &&
                                  Array.isArray(values.cv)
                                  ? values.cv.map((file, idx) => {
                                    const isString = typeof file === "string";
                                    const isFileObj = file instanceof File;

                                    return {
                                      id: idx,
                                      file: isString
                                        ? file
                                        : file?.preview
                                          ? file?.preview
                                          : URL?.createObjectURL(file),

                                      name:
                                        file?.name || `cv-${idx}`,

                                      // Detect type correctly
                                      type: isString
                                        ? file?.endsWith(".pdf")
                                          ? "pdf"
                                          : "image"
                                        : file?.type?.includes("pdf")
                                          ? "pdf"
                                          : file?.type?.includes("zip")
                                            ? "zip"
                                            : "image",

                                      preview: file.preview || null, // 🔥 keep preview if exists
                                      isExisting: true,
                                    };
                                  })
                                  : []
                              }
                              onChange={(newFiles) => {
                                setTouched({ cv: true });
                                setFieldValue("cv", newFiles); // store array of files
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"cv"}
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Portfolio or Website
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="Portfolio or website"
                              type="text"
                              id="website_or_portfolio"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.website_or_portfolio || ""}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"website_or_portfolio"}
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_darkblue_text ct_fs_14">
                              {" "}
                              Upload Project to Nuvio (Minimum 3){" "}
                            </label>
                            <PdfOrImageUploader
                              maxFiles={20}
                              multiple={true}
                              acceptType=".zip,application/zip"
                              placeholder="Upload Project ZIP files"
                              existingFiles={
                                Array.isArray(values?.cv)
                                  ? values.cv
                                    .map((file, idx) => {
                                      if (typeof file === "string") {
                                        return {
                                          id: idx,
                                          file,
                                          name: file.split("/").pop(),
                                          type: file.endsWith(".pdf") ? "pdf" : "image",
                                          isExisting: true,
                                        };
                                      }
                                      if (file instanceof File) {
                                        const preview = URL?.createObjectURL(file);
                                        return {
                                          id: idx,
                                          file: preview,
                                          name: file.name,
                                          type: file.type.includes("pdf") ? "pdf" : "image",
                                          preview,
                                          isExisting: false,
                                        };
                                      }
                                      return null; // ❗ avoid crash
                                    })
                                    .filter(Boolean)
                                  : []
                              }
                              onChange={(newFiles) => {
                                setTouched({ projects: true });
                                setFieldValue("projects", newFiles); // store array of files
                              }}
                            />

                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"projects"}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-2">
                        <button
                          type="submit"
                          // onClick={(e) => goTo(e, coachPaths.CoachSignUpStep2)}
                          onClick={handleSubmit}
                          class="ct_yellow_btn  w-100 mx-auto"
                        >
                          Continue
                        </button>
                      </div>
                      <StepsDots steps={[1, 2, 3, 4]} activeStep={3} />
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileSetupStep3;
